import { useNavigate } from "react-router-dom";
import { FaSignInAlt } from "react-icons/fa";
import { HiLockClosed } from "react-icons/hi";
import { clearSession } from "../../utils/storage";

const SessionExpiredPage = () => {
  const navigate = useNavigate();

  const goLogin = () => {
    clearSession();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-surface-low flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-surface-container/60 flex items-center justify-center mx-auto mb-6">
          <HiLockClosed className="text-primary text-3xl" />
        </div>
        <h1 className="text-2xl font-bold text-on-primary-fixed-var mb-3">Session Expired</h1>
        <p className="text-on-surface-variant text-sm mb-8 leading-relaxed">
          For your security, you have been automatically logged out due to inactivity.
        </p>
        <button
          type="button"
          onClick={goLogin}
          className="w-full inline-flex items-center justify-center gap-2 bg-primary text-white px-6 py-3 rounded-full font-semibold hover:bg-primary-container transition-colors mb-4"
        >
          Log In Again
          <FaSignInAlt size={14} />
        </button>
        <button
          type="button"
          onClick={goLogin}
          className="text-primary font-semibold text-sm hover:underline"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredPage;
